import { RequestBlockStatus } from '@/api/types/enums';
import type { RequestBlock } from '@/api/types/requestFlow';

type RequestBlockStatusOnly = Pick<RequestBlock, 'status'>;

/**
 * A block counts towards a request's Progress (spec §2.4): for an auditor once it is
 * confirmed (reviewed), for a client once it is sent — submitted, or already confirmed.
 */
export function isRequestBlockCompleted(
  block: RequestBlockStatusOnly,
  isAuditor: boolean,
): boolean {
  if (block.status === RequestBlockStatus.confirmed) return true;
  return !isAuditor && block.status === RequestBlockStatus.marked_done;
}

/**
 * A request's Progress is completed once every block is. A request without blocks has no
 * Progress, so it is never completed.
 */
export function isRequestProgressCompleted(
  blocks: RequestBlockStatusOnly[],
  isAuditor: boolean,
): boolean {
  return blocks.length > 0 && blocks.every((block) => isRequestBlockCompleted(block, isAuditor));
}
